import { SummeryInvestmentsDTO } from '@/types/models';
import { client } from '@/api/client';
export const getSummeryInvestments = async (): Promise<SummeryInvestmentsDTO> => {
  try {
    const result = await client.get('/investments');
    return result.data;
  } catch (error) {
    return {
      investors_count: 0,
      users_investments_sum: 0,
      received_profits_sum: 0
    };
  }
};
export const summeryInvestmentsOptions = {
  queryKey: ['summery-investments'],
  queryFn: () => getSummeryInvestments()
};